export default {"src":"/_next/static/image/public/images/flags/flag_1784.6083ac5ab3449ce2c9805cc82a38b3f0.svg","height":16,"width":24};